import React, { useState, useEffect } from 'react';
import {
  Paper,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Checkbox,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Divider,
  CircularProgress,
  Autocomplete,
} from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";

import { makeStyles } from "@material-ui/styles";
import Card from '../../StyledComponents/Card/Card';
import CardHeader from '../../StyledComponents/Card/CardHeader';
import CardText from '../../StyledComponents/Card/CardText';
import CardBody from '../../StyledComponents/Card/CardBody';
import { Backdrop } from "@material-ui/core";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TableSkeleton from '../../StyledComponents/TableSkeleton';
import { dashboardStyle } from '../Invoices/Components/InvoiceDetails/style';
import Tooltip from "@mui/material/Tooltip";
import CustomSnackbar from '../../CustomSnackbar';
import AddUserModel from './AddUserModel';
import TabelSkeleton from "../../StyledComponents/TableSkeleton"
import EmptyData from '../../StyledComponents/Table/EmptyData';

import { get_Location, getUserByLocation, create_user, getData, DeleteUser, fetch_data_by_id } from "./actionConfiguration"

const APSConfiguration = () => {

  const [openModel, setOpenModel] = useState(false);

  const [getUser, setgetUser] = useState([]);
  const useStyles = makeStyles(dashboardStyle);
  const classes = useStyles();



  const [userloader, setUserLoader] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [error, seterror] = useState(false);
  const [togglebutton, settogglebutton] = useState(null);
  const [statusLoading, setStatusLoading] = useState(false);

  const [deleteId, setDeleteID] = useState("");
  const [userId, setUserID] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [locationOption, setLocationOption] = React.useState([]);
  const [getuserdata, setgetUserdata] = useState([]);
  const [searchApi, setSearchAPi] = useState([])
  const [formState, setFormState] = useState({

    location: "",
    userName: "",
    limit: 0,
    created_By: "string",
    creadetd_Date: null,
    updated_By: "string",
    updated_Date: null

  });

  const handleOpenModel = () => {
    setOpenModel(true);
  };

  const handleCloseModel = () => {
    setOpenModel(false);
    seterror(false)
    setFormState({
      location: "",
      userName: "",
      limit: ""
    })

  };
  const changehandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
    if (name === "location") {
      getUserByLocation("AP Supervisor", value, setgetUserdata, setStatusLoading)

    }
  };
  const handleSearchInput = (e) => {

    if (e.target.value === "") {
      setgetUser(searchApi)
    } else {
      const fiterData = searchApi.filter((data =>
        data.userName
          .toLowerCase()
          .includes(searchInput.toLowerCase()) ||
        data.location
          .toLowerCase()
          .includes(searchInput.toLowerCase())


      ))
      if (fiterData.length > 0) {
        setgetUser(fiterData)

      } else {
        let msg = "No Records Found"
        setgetUser([{ message: msg }])
      }
    }
  }


  const ITEM_HEIGHT = 40;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  useEffect(() => {
    get_Location(setLocationOption, setStatusLoading)
    getData(setgetUser, setStatusLoading, setSearchAPi)
  }, []);
  return (
    <div>

      <Box display="flex" justifyContent={"end"}>
        <Button
          variant="contained"
          size={"small"}
          color="secondary"
          sx={{
            color: "#fff",
            fontSize: "15px",
            marginTop: "4px",
            width: "151px",
          }}
          onClick={() => {
            setDeleteID("");
            setOpenModel(true)
            setFormState({
              location: "",
              userName: "",
              limit: ""
            })
            settogglebutton(null)

          }}
        >
          {/* <AddIcon /> */}
          Add APS User
        </Button>
      </Box>
      <Card style={{ marginTop: "24px" }}>
        <CardHeader color="primary" text>
          <CardText color="primary" style={{ padding: "0px 27px" }}>
            {/* <Box> */}
            <h4>Add/Edit User</h4>

            {/* </Box> */}
          </CardText>
        </CardHeader>
        <CardBody>
          <Grid container spacing={2} pb={3}>
            <Grid item md={4} sx={3} mt={2} ml={1}>
              <TextField
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    height: 30,
                  }
                }}
                fullWidth
                id="outlined-basic"
                placeholder="Search here...."
                variant="outlined"
                value={searchInput}
                type="search"
                onChange={(e) => {
                  handleSearchInput(e)

                  setSearchInput(e.target.value)
                }}
              />
            </Grid>
          </Grid>
          <TableContainer className="scrollable"

            sx={{
              height: 400
            }}
          >

            <Table
              className={classes.table}
              aria-label="a dense table"
              style={{ padding: "0px 27px" }}
              // padding="normal"
              size="small"
              sx={{
                height: "max-content"
              }}
            >
              <TableHead
                style={{
                  position: 'sticky',
                  top: '0px',
                }}>
                <TableRow sx={{ backgroundColor: "#A5ACB0" }}>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#fff", width: 200 }}
                  >
                    SR#
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                    User Name
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                    User Location
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                    Limit
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ fontWeight: "bold", color: "#fff" }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody >
                {getUser.map((item, index) => {
                  return (
                    <>
                      {item.message ? (
                        <>

                          <TableRow
                          // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                          >
                            <TableCell colSpan={5}
                              style={{

                                border: "none",
                                textAlign: "center",
                                padding: "20px 10px 20px",

                              }}
                            >
                              <Typography>No Records Found</Typography>

                            </TableCell>

                          </TableRow>
                        </>

                      ) : (
                        <TableRow
                          key={1}
                        // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                        >
                          <TableCell scope="row">{index + 1}</TableCell>
                          <TableCell>{
                            item.userName

                          }</TableCell>
                          <TableCell>{item.location}</TableCell>
                          <TableCell>{item.limit}</TableCell>
                          <TableCell align="right">
                            <Tooltip title="Edit">
                              <EditIcon
                                color="success"
                                sx={{ "&:hover": { cursor: "pointer" } }}
                                onClick={() => {
                                  setDeleteID("");
                                  setUserID(item.apsConfigurationId)
                                  settogglebutton(1);



                                  fetch_data_by_id(
                                    item.apsConfigurationId, locationOption, getUserByLocation,
                                    setgetUserdata, setStatusLoading, setFormState)
                                  handleOpenModel();
                                }}


                              />
                            </Tooltip>
                            <Tooltip title="Delete">
                              <DeleteIcon
                                color="error"
                                sx={{ "&:hover": { cursor: "pointer" } }}
                                onClick={() => {
                                  setDeleteID(item.apsConfigurationId);
                                  settogglebutton(null);
                                  handleOpenModel();
                                }}
                              />
                            </Tooltip>


                          </TableCell>
                        </TableRow>

                      )}

                    </>
                  );
                })}
              </TableBody>
              {statusLoading && <TabelSkeleton noOfColumns={5} noOfLines={3} />}
            </Table>
            {getUser?.length === 0 && !statusLoading ? <EmptyData /> : ""}
          </TableContainer>
        </CardBody>
      </Card>
      <form>
        <Dialog open={openModel} onClose={handleCloseModel} fullWidth>
          {deleteId ? (
            <>
              <DialogContent>
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={userloader}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <HelpOutline color="secondary" fontSize="large" mt={2} />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  p={2}
                  mt={1}
                >
                  <Typography variant="h4" style={{ width: "80%" }}>
                    Are you sure you want to Delete a User?
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  m={1}
                >
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleCloseModel}
                  >
                    NO
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    style={{ marginLeft: "20px" }}
                    onClick={() => {
                      DeleteUser(deleteId, setUserLoader, getData, setgetUser, handleCloseModel);
                    }}
                  >
                    Yes
                  </Button>
                </Box>
              </DialogContent>
            </>
          ) : (
            <>
              <DialogTitle
                sx={{
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                {togglebutton ? "Update User" : "Create User"}
              </DialogTitle>
              <Divider />
              <DialogContent>
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={userloader}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>

                <Grid container spacing={2} pb={3}>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth size="small">
                      <Typography>
                        Select Location{" "}
                        <span className={classes.asterisk}>*</span>
                      </Typography>
                      <Select
                        displayEmpty
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        name="location"
                        value={formState.location}
                        onChange={changehandler}




                        MenuProps={MenuProps}
                      >
                        <MenuItem value="" disabled> Select a  Value</MenuItem>
                        {locationOption.map((item, index) => (
                          <MenuItem key={index} value={item.id}>{item.location}</MenuItem>
                        ))}


                      </Select>
                      {error && formState.location == "" ? (
                        <>
                          <Typography variant="h6" component="h6" color="error">
                            loaction is required
                          </Typography>
                        </>
                      ) : null}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth size="small">

                      <Typography>
                        APS user
                        <span className={classes.asterisk}>*</span>
                      </Typography>
                      <Select
                        labelId="demo-simple-name-label"
                        id="demo-simple-name"
                        name="userName"
                        displayEmpty
                        value={formState.userName}
                        className={classes.selectEmpty}
                        onChange={changehandler}
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={MenuProps}
                      //  InputLabelProps={{ shrink: false, required: false, className: classes.hs_form_required }}
                      // select
                      // fullWidth
                      // size="small"
                      >
                        <MenuItem value="" disabled>
                          Select a  Value
                        </MenuItem>


                        {!statusLoading ? (
                          getuserdata.length > 0 ? (
                            getuserdata.map((item, index) => (
                              <MenuItem key={index} value={item.userId}>
                                {item.userName}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>Not Found</MenuItem>
                          )
                        ) : (
                          <MenuItem>
                            <CircularProgress size={24} />
                          </MenuItem>
                        )}
                      </Select>
                      {error && formState.userName == "" ? (
                        <>
                          <Typography variant="h6" component="h6" color="error">
                            loaction is required
                          </Typography>
                        </>
                      ) : null}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography>
                      Add Limit{" "}
                      <span className={classes.asterisk}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      name="limit"
                      type="number"
                      min="0"
                      value={formState?.limit || "0"}
                      sx={{
                        // width: "70%",
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      onChange={changehandler}
                      // inputProps={{ maxLength: 16 }}
                      // placeholder ="Add limit"
                      required
                    />
                    {error && formState?.limit == "" ? (
                      <>
                        <Typography variant="h6" component="h6" color="error">
                          loaction is required
                        </Typography>
                      </>
                    ) : null}
                  </Grid>

                </Grid>
              </DialogContent>
              <Divider />

              <DialogActions>
                <Button variant="outlined" color="error" onClick={handleCloseModel}>
                  Cancel
                </Button>
                {togglebutton ? (
                  <Button
                    color="success"
                    variant="contained"

                    onClick={() => { create_user(setFormState, formState, setUserLoader, setSuccessMessage, setErrorMessage, getData, setgetUser, handleCloseModel, seterror, userId) }}
                  >
                    Updated
                  </Button>
                ) : (<Button
                  color="secondary"
                  variant="contained"
                  type="submit"
                  onClick={() => { create_user(setFormState, formState, setUserLoader, setSuccessMessage, setErrorMessage, getData, setgetUser, handleCloseModel, seterror) }}
                >
                  Save
                </Button>)}

              </DialogActions>
            </>)}

        </Dialog>
      </form>

      {successMessage && (
        <CustomSnackbar
          open={true}
          message={successMessage}
          handleClose={() => setSuccessMessage("")}
          variant="success"
        />
      )}
      {errorMessage && (
        <CustomSnackbar
          open={errorMessage !== ""}
          message={errorMessage}
          handleClose={() => setErrorMessage("")}
          variant="error"
        />
      )}

    </div>
  );
}

export default APSConfiguration;
